import { DownArrow, EyesIcon, LikeIcon, LinkArrowIcon, VideoImage } from 'assets'

import { DropDown, VideoCard } from 'components'
import { useOutsideClick } from 'Hooks'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getTopVideoListAction } from 'store/action/settingsReducer'
import { onResetVideoCount } from 'store/action/videoReducer'

function VideoSection() {
   const [videoFilter, setVideoFilter] = useState('Recent Posted')
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const settingData = useSelector((state) => state.settings)
   const { channelDetails, getTopVideoList } = settingData
   const authData = useSelector((state) => state.user)
   const { isDashboard } = authData
   const location = useLocation()

   const onSeletedValue = (data) => {
      setVideoFilter(data)
   }

   useEffect(() => {
      if (channelDetails?.channel_id && !isDashboard) {
         dispatch(getTopVideoListAction({ channel_id: channelDetails?.channel_id }))
         // dispatch(onResetVideoCount())
      }
      return () => {}
   }, [channelDetails])

   return (
      <div className="video-section">
         {getTopVideoList && getTopVideoList.length > 0 ? (
            <>
               <div className="video-title-section">
                  <div className="">
                     <p className="at-text-dark at-font-20">Total Videos</p>
                     {/* <span className="at-text-light  at-font-14">242 Items</span> */}
                  </div>
                  <div className="d-flex align-items-center justify-content-start gap-3">
                     {/* <DropDown
                  option={[
                     { label: 'Recent Posted', value: 'Recent Posted' },
                     { label: 'Recent Posted 1', value: 'Recent Posted 1' },
                     { label: 'Recent Posted 2', value: 'Recent Posted 2' }
                  ]}
                  value={videoFilter}
                  onChangeOpt={onSeletedValue}
               /> */}
                     <div
                        className="channel-btn"
                        onClick={() => {
                           navigate(`/videos${location?.search}`)
                        }}>
                        <span>All Videos</span>
                        <LinkArrowIcon />
                     </div>
                  </div>
               </div>
               <div className="video-wrap mt-3">
                  <div className="row">
                     {getTopVideoList &&
                        getTopVideoList?.length > 0 &&
                        getTopVideoList?.map((item, i) => {
                           return (
                              <div className="col-12 col-lg-4 mt-2" key={i}>
                                 <VideoCard items={item?.video} />
                              </div>
                           )
                        })}
                  </div>
               </div>
            </>
         ) : null}
      </div>
   )
}

export default VideoSection
